





























import { CreateElement, VNode } from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { TableEntryGroup } from './types';
import SwTable from './sw-table.vue';

const cssPrefix = 'sw-table-group-row';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwTableGroupRow extends SwExtendedVue {
  @Prop({ type: String, required: true })
  instanceId: string;

  @Prop({ type: Object, required: true })
  group: TableEntryGroup;

  @Prop({ type: Number, required: true })
  index: number;

  @Prop({ type: Boolean, default: false })
  collapsed: boolean;

  cssPrefix = cssPrefix;

  @Inject()
  private claimGroupCollapseRequest: SwTable['claimGroupCollapseRequest'];

  private onClickTrigger() {
    this.claimGroupCollapseRequest(this.group, !this.collapsed);
  }

  private render(h: CreateElement): VNode {// tslint:disable-line
    const rootNode = (
      <div class={[`${this.cssPrefix}`, `${this.cssPrefix}--${this.instanceId}`, 'sw-flexbox', 'sw-flexbox--center-items', this.group.className || '']}>
        <div class={[`${this.cssPrefix}__trigger`, { [`${this.cssPrefix}__trigger--collapsed`]: this.collapsed }, 'sw-flexbox__flex-none']}
          on-click={this.onClickTrigger}
        >
          <sw-icon
            name="arrow-up"
            size={12}
            as-block
          ></sw-icon>
        </div>
        <div class={[`${this.cssPrefix}__label`, 'sw-flexbox__flex']}>
        {
          typeof this.group.label === 'string' ? this.group.label :
            this.group.label(h, { group: this.group, index: this.index })
        }
        </div>
      </div>
    );

    return rootNode as VNode;
  }
}
